export default eventAction => {
  window.ga('send', {
    hitType: 'event',
    eventCategory: 'External link',
    eventAction,
  });
};



// WEBPACK FOOTER //
// ./src/ga/gaUserClickedLink.js